import React from 'react'
import styled from 'styled-components'

const Adr = styled.div`
  color: ${({ theme }) => theme.colors.fadedRed.hex()};
  font-weight: 600;
  font-size: 0.875rem;
  text-align: center;
  line-height: 32px;
  width: 69px;
  height: 32px;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.colors.fadedRed.hex()};
  white-space: nowrap;
`

export default ({ adrClass }) => <Adr>{`ADR ${adrClass || ''}`}</Adr>
